import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import imagesWithBlurSchema from '@utils/validate/blocksSchemes/imagesWithBlurSchema';
const inspirationProductGallerySingleSchema = Joi.object({
  type: Joi.string().valid('inspirationProductGallerySingle').required(),
  code: Joi.string().allow('', null).required(),
  variant: Joi.string().allow('', null),
  background: Joi.string().allow('', null),
  products: Joi.array().items(Joi.object().unknown(true)),
  productBottom: Joi.array().items(Joi.object().unknown(true)),
  image: mediaUrlSchema.required(),
  leftTextColor: Joi.string().allow('', null),
  leftText: Joi.string().allow('', null),
  rightTextColor: Joi.string().allow('', null),
  rightText: Joi.string().allow('', null),
  imageWithBlur: imagesWithBlurSchema.allow('', null)
}).unknown(true);
export default inspirationProductGallerySingleSchema;